/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TemplateVariableDto } from './TemplateVariableDto';
import {
    TemplateVariableDtoFromJSON,
    TemplateVariableDtoFromJSONTyped,
    TemplateVariableDtoToJSON,
    TemplateVariableDtoToJSONTyped,
} from './TemplateVariableDto';
import type { EmailRecipientDto } from './EmailRecipientDto';
import {
    EmailRecipientDtoFromJSON,
    EmailRecipientDtoFromJSONTyped,
    EmailRecipientDtoToJSON,
    EmailRecipientDtoToJSONTyped,
} from './EmailRecipientDto';

/**
 * Reponse contenant l'apercu du template email
 * @export
 * @interface TemplatePreviewResponse
 */
export interface TemplatePreviewResponse {
    /**
     * Indique si la recuperation de l'apercu a reussi
     * @type {boolean}
     * @memberof TemplatePreviewResponse
     */
    isSuccess?: boolean;
    /**
     * File label of the document
     * @type {string}
     * @memberof TemplatePreviewResponse
     */
    fileLabel?: string;
    /**
     * Contenu HTML du template avec les variables resolues
     * @type {string}
     * @memberof TemplatePreviewResponse
     */
    htmlContent?: string | null;
    /**
     * Sujet de l'email avec les variables resolues
     * @type {string}
     * @memberof TemplatePreviewResponse
     */
    subject?: string | null;
    /**
     * Message d'erreur en cas d'echec
     * @type {string}
     * @memberof TemplatePreviewResponse
     */
    errorMessage?: string | null;
    /**
     * Liste des variables du template avec leur valeur et flag IsCustomizable. Format des noms - {{nom}} (sans params.)
     * @type {Array<TemplateVariableDto>}
     * @memberof TemplatePreviewResponse
     */
    variables?: Array<TemplateVariableDto>;
    /**
     * Copies (CC) ajoutees automatiquement a l'envoi (ex - le courtier du risque). Affichees en lecture seule dans la modale ; absent/vide = rien a afficher.
     * 
     * @type {Array<EmailRecipientDto>}
     * @memberof TemplatePreviewResponse
     */
    ccRecipients?: Array<EmailRecipientDto> | null;
}

/**
 * Check if a given object implements the TemplatePreviewResponse interface.
 */
export function instanceOfTemplatePreviewResponse(value: object): value is TemplatePreviewResponse {
    return true;
}

export function TemplatePreviewResponseFromJSON(json: any): TemplatePreviewResponse {
    return TemplatePreviewResponseFromJSONTyped(json, false);
}

export function TemplatePreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplatePreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'fileLabel': json['fileLabel'] == null ? undefined : json['fileLabel'],
        'htmlContent': json['htmlContent'] == null ? undefined : json['htmlContent'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(TemplateVariableDtoFromJSON)),
        'ccRecipients': json['ccRecipients'] == null ? undefined : ((json['ccRecipients'] as Array<any>).map(EmailRecipientDtoFromJSON)),
    };
}

export function TemplatePreviewResponseToJSON(json: any): TemplatePreviewResponse {
    return TemplatePreviewResponseToJSONTyped(json, false);
}

export function TemplatePreviewResponseToJSONTyped(value?: TemplatePreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'fileLabel': value['fileLabel'],
        'htmlContent': value['htmlContent'],
        'subject': value['subject'],
        'errorMessage': value['errorMessage'],
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(TemplateVariableDtoToJSON)),
        'ccRecipients': value['ccRecipients'] == null ? undefined : ((value['ccRecipients'] as Array<any>).map(EmailRecipientDtoToJSON)),
    };
}

